import React from "react";
import { Button } from "primereact/button";

export default function SwipperController({ swiper, index }) {
  return (
    <React.Fragment>
      {/* large  */}
      <div
        className="hidden md:flex md:absolute md:flex-column gap-2"
        style={{ right: 0, bottom: 5 }}
      >
        <Button
          className="bg-white-alpha-10 p-1"
          style={{ borderRadius: 1000 }}
          onClick={() => swiper.slidePrev()}
        >
          <i className="pi pi-chevron-up text-xs p-0 m-0" />
        </Button>
        <div className="flex flex-column gap-2 justify-content-center align-items-center md:h-12rem">
          <div
            className="hidden md:flex"
            style={{
              height: index === 0 ? "100%" : "30%",
              backgroundColor: index === 0 ? "white" : "gray",
              padding: 1.5,
            }}
          />

          <div
            className="hidden md:flex"
            style={{
              height: index === 1 ? "100%" : "30%",
              backgroundColor: index === 1 ? "white" : "gray",
              padding: 1.5,
            }}
          />
        </div>
        <Button
          className="bg-white-alpha-10 p-1"
          style={{ borderRadius: 1000 }}
          onClick={() => swiper.slideNext()}
        >
          <i className="pi pi-chevron-down text-xs p-0 m-0" />
        </Button>
      </div>

      {/* small */}

      <div
        className="flex md:hidden gap-2 align-items-center"
        style={{ right: 0, bottom: 5 }}
      >
        <Button
          className="bg-white-alpha-10 p-1"
          style={{ borderRadius: 1000 }}
          onClick={() => swiper.slidePrev()}
        >
          <i className="pi pi-chevron-left text-xs p-0 m-0" />
        </Button>
        <div className="flex  gap-2 justify-content-center align-items-center w-12rem">
          <div className="w-full flex gap-2">
            <div
              className="flex md:hidden"
              style={{
                width: index === 0 ? "100%" : "30%",
                backgroundColor: index === 0 ? "white" : "gray",
                padding: 1.5,
              }}
            />
            <div
              className="flex md:hidden"
              style={{
                width: index === 1 ? "100%" : "30%",
                backgroundColor: index === 1 ? "white" : "gray",
                padding: 1.5,
              }}
            />
          </div>
        </div>
        <Button
          className="bg-white-alpha-10 p-1"
          style={{ borderRadius: 1000 }}
          onClick={() => swiper.slideNext()}
        >
          <i className="pi pi-chevron-right text-xs p-0 m-0" />
        </Button>
      </div>
    </React.Fragment>
  );
}
